import {defineStore} from "pinia/dist/pinia";

export const useLatitudeStore = defineStore('LatitudeStore', {
    state() {
        return {
            selectedPolizzaLatitudineState: null,
            risultatoEvasioneRichiestaState: null,
            anagraficaEstesaState: [],
            anagraficaEstesaFiltersState: {},
            provinceState: [],
            risultatoAnalisiState: null,
            IDStoricoUploadState: null
        }
    },
    getters: {
        selectedPolizzaLatitudine() { return this.selectedPolizzaLatitudineState },
        risultatoEvasioneRichiesta() { return this.risultatoEvasioneRichiestaState },
        anagraficaEstesa() { return this.anagraficaEstesaState },
        anagraficaEstesaFilters() { return this.anagraficaEstesaFiltersState },
        province() { return this.provinceState },
        risultatoAnalisi() { return this.risultatoAnalisiState },
        IDStoricoUpload() { return this.IDStoricoUploadState },
    },
    actions: {
        setContract(contract){ this.selectedPolizzaLatitudineState = contract},
        setRisultatoEvasioneRichiesta(risultatoEvasioneRichiesta){ this.risultatoEvasioneRichiestaState = risultatoEvasioneRichiesta},
        setAnagraficaEstesa(anagraficaEstesa){ this.anagraficaEstesaState = anagraficaEstesa },
        setAnagraficaEstesaFilters(filters){ this.anagraficaEstesaFiltersState = filters },
        setProvince(province){ this.provinceState = province },
        setRisultatoAnalisi(risultatoAnalisi){ this.risultatoAnalisiState = risultatoAnalisi },
        setIDStoricoUpload(id){ this.IDStoricoUploadState = id }
    }
})